import React from "react";
import { useAuth } from "../../common/auth";
import { OverviewCounts, getOverviewCounts } from "../../common/requests/overview/endpoints";
import { Resource, useResource } from "../../ui/hooks";

const CountsContext = React.createContext<Resource<OverviewCounts> | null>(null);

/** Server-side "needs you" counts for the sidebar badges and the Overview
 * inbox, refreshed every minute while the tab is visible. */
export function CountsProvider({ children }: { children: React.ReactNode }) {
  const { idToken } = useAuth();
  const counts = useResource<OverviewCounts>(async () => (await getOverviewCounts(idToken!)).data, [idToken], {
    enabled: !!idToken,
    pollMs: 60_000,
  });
  return <CountsContext.Provider value={counts}>{children}</CountsContext.Provider>;
}

export function useCounts(): Resource<OverviewCounts> {
  const ctx = React.useContext(CountsContext);
  if (!ctx) throw new Error("useCounts must be used inside CountsProvider");
  return ctx;
}

/** The counts when inside CountsProvider, else null (pages rendered alone in tests). */
export function useOptionalCounts(): Resource<OverviewCounts> | null {
  return React.useContext(CountsContext);
}
